import { getApiBaseUrl } from '../utils/apiConfig.js';

const API_BASE_URL = getApiBaseUrl();
const FLIGHT_API = `${API_BASE_URL}/flights`;

async function request(path, options = {}) {
  const resp = await fetch(`${FLIGHT_API}${path}`, {
    credentials: 'include',
    ...options,
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.detail || '请求失败');
  }
  return data;
}

export async function getFlightAirports() {
  return request('/airports');
}

// payload: { origin, destination, depart_date, return_date?, trip_type, legs?, cabin, adults, children, infants }
export async function searchFlights(payload) {
  return request('/search', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export async function createFlightOrder(payload) {
  return request('/orders', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export async function listFlightOrders(params = {}) {
  const qs = new URLSearchParams();
  if (params.status) qs.set('status', params.status);
  if (params.skip) qs.set('skip', params.skip);
  if (params.limit) qs.set('limit', params.limit);
  return request(`/orders?${qs.toString()}`);
}

export async function getFlightOrder(orderId) {
  return request(`/orders/${orderId}`);
}

export async function cancelFlightOrder(orderId) {
  return request(`/orders/${orderId}/cancel`, { method: 'POST' });
}

export async function adminListFlightOrders(params = {}) {
  const qs = new URLSearchParams();
  if (params.status) qs.set('status', params.status);
  if (params.q) qs.set('q', params.q);
  if (params.limit) qs.set('limit', params.limit);
  return request(`/admin/orders?${qs.toString()}`);
}

export async function adminTransitionFlightOrder(orderId, body) {
  return request(`/admin/orders/${orderId}/transition`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}
